import { render, staticRenderFns } from "./IcoPersonPlus.vue?vue&type=template&id=cfac95e2"
import script from "./IcoPersonPlus.vue?vue&type=script&lang=js"
export * from "./IcoPersonPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports